import React from "react";
import DomainGeneralInfo from "../GeneralInfo";
import CardContainer from "../../../../components/Common/CardContainer";
import ButtonInput from "../../../../components/Common/ButtonInput";
import * as BootstrapVariants from "../../../../constants/Bootstrap/Variants";

const DomainDetails = (props) => {
  const handleReturn = () => {
    // check how we got here ( from school or from college )
    if (props.match.params.collegeId) {
      props.history.push(
        `/schools/${props.match.params.schoolId}/colleges/details/${props.match.params.collegeId}/tab/Domains`
      );
    } else {
      props.history.push(
        `/schools/details/${props.match.params.schoolId}/tab/Domains`
      );
    }
  };
  return (
    <CardContainer
      header={"Domain Details"}
      backButton={
        <ButtonInput
          label="Back to List"
          type="button"
          variant={BootstrapVariants.OutlineSecondary}
          onClick={() => handleReturn()}
        />
      }
    >
      <DomainGeneralInfo domainId={props.match.params.domainId} />
    </CardContainer>
  );
};

export default DomainDetails;
